module.exports = __webpack_public_path__ + "static/media/arrows-merge.f57b06d9.svg";